<template>
    <div class="wrapper relative flex justify-center">
        <div
            v-if="topText && !icon"
            ref="topText"
            class="h-6 w-auto text-xs uppercase text-top absolute inline-block text-gold-500">
            {{ topText
            }}
        </div>
        <svg-icon
            v-if="icon"
            ref="icon"
            :icon="icon"
            class="icon-top w-4 h-4 block text-gold-500 absolute" />
        <tis-button
            ref="button"
            class="btn-icon-topped block hover:scale-95"
            handle-redraw="handleRedraw"
            :url="url"
            :target="target"
            :full-redirect="fullRedirect"
        >
            {{ label }}
            <resize-observer @notify="handleRedraw" />
        </tis-button>
    </div>
</template>

<script>
import SvgIcon from '@whisper/components/icons/SvgIcon';
import TisButton from '@whisper/components/buttons/TisButton';

export default {
  name: 'TisIconToppedWrapper',
  components: { TisButton, SvgIcon },
  props: ['icon', 'label', 'url', 'target', 'topText', 'fullRedirect'],
  data: () => ({
    buttonWidth: '',
    buttonHeight: '',
    iconWidth: '',
    iconHeight: '',
    topLeftCutoffPoint: '',
    topRightCutoffPoint: '',
    iconPositionLeft: '',
    iconPositionTop: '',
    dynamicClipPath: '',
  }),
  mounted() {
    this.handleRedraw();
  },
  methods: {
    handleRedraw() {
      this.getButtonSize();
      this.getIconSize();
      this.setCutoffPoints();
      this.setIconPosition();
      this.setDynamicClipPath();
      this.$refs.button.$el.style.clipPath = this.dynamicClipPath;
    },
    getButtonSize() {
      this.buttonWidth = this.$refs.button.$el.clientWidth;
      this.buttonHeight = this.$refs.button.$el.clientHeight;
    },
    getIconSize() {
      if (this.icon && !this.topText) {
        this.iconWidth = this.$refs.icon.$el.clientWidth;
        this.iconHeight = this.$refs.icon.$el.clientHeight;
      }

      if (this.topText && !this.icon) {
        this.iconWidth = this.$refs.topText.clientWidth;
        this.iconHeight = this.$refs.topText.clientHeight;
      }
    },

    setCutoffPoints() {
      this.topLeftCutoffPoint = this.topLeftCutoffPoint = (`${this.buttonWidth / 2 - this.iconWidth / 2 - 5}px`);
      this.topRightCutoffPoint = (`${this.buttonWidth / 2 + this.iconWidth / 2 + 5}px`);
    },
    setIconPosition() {
      this.iconPositionLeft = this.buttonWidth / 2 - this.iconWidth / 2;
      this.iconPositionTop = (this.iconHeight / 2);
    },
    setDynamicClipPath() {
      this.dynamicClipPath = (`polygon(
             0% 100%, 100% 100%, 100% 0%,
             ${this.topRightCutoffPoint} 0%,
             ${this.topRightCutoffPoint} ${this.iconHeight / 2}px,
             ${this.topLeftCutoffPoint} ${this.iconHeight / 2}px,
             ${this.topLeftCutoffPoint} 0%, 0% 0%)`);
    },
  },
};
</script>

<style scoped>
    .icon-top {
        top: -0.65rem;
    }

    .text-top {
        top: -0.5rem;
    }
</style>
